export default __webpack_public_path__ + "static/media/cartop-pm8.9fab0143.jpg";